<nav class="sidebar sidebar-offcanvas" id="sidebar">
  <ul class="nav">
    <li class="nav-item navbar-brand-mini-wrapper">
      <a class="nav-link navbar-brand brand-logo-mini" href="index.html"><img src="assets/images/logo.png" alt="logo"/></a>
    </li>

    <ng-container *ngFor="let group of menuGroups">
      <li class="nav-item nav-category">
        <span class="nav-link">{{ group.categoryTitle | translate }}</span>
      </li>

      <ng-container *ngFor="let item of group.items">
        <li class="nav-item" *ngIf="!item.children" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
          <a class="nav-link" [routerLink]="item.route">
            <span class="menu-title">{{ item.title | translate }}</span>
            <i class="menu-icon" [ngClass]="item.icon"></i>
          </a>
        </li>

        <li class="nav-item" *ngIf="item.children" routerLinkActive="active">
          <a class="nav-link" (click)="clickedMenu($event)" [id]="item.id" [attr.aria-controls]="item.id" style="cursor: pointer;">
            <span class="menu-title">{{ item.title | translate }}</span>
            <i class="menu-icon" [ngClass]="item.icon"></i>
          </a>
          <div class="collapse" [id]="item.id" [ngbCollapse]="parentId !== item.id">
            <ul class="nav flex-column sub-menu">
              <li class="nav-item" *ngFor="let child of item.children">
                <a class="nav-link" [routerLink]="child.route" routerLinkActive="active">
                  {{ child.title | translate }}
                </a>
              </li>
            </ul>
          </div>
        </li>
      </ng-container>
    </ng-container>

  </ul>
</nav>
